/* eslint-disable global-require */
const audios = {
  click: require('./click.mp3'),
  pop: require('./pop.mp3'),
  slide: require('./slide.mp3'),
  tap: require('./tap.mp3'),
  levelMasteryK3: require('./level_mastery_k_3.mp3'),
  levelMastery45: require('./level_mastery_4_5.mp3'),
  analyzing: require('./gsfx_transition_activity.mp3'),
  stop: require('./sfx_next_item.mp3'),
  correctFeedback: require('./gsfx_correct_feedback.mp3'),
  incorrectFeedback: require('./gsfx_incorrect_feedback.mp3'),
};

export default audios;
